import { Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-296ecd0b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "auth" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, "Login", -1))
const _hoisted_3 = { class: "body sign-in" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Email", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Password", -1))
const _hoisted_6 = {
  key: 0,
  class: "error-message"
}
const _hoisted_7 = { class: "button-wrapper" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, "Signup", -1))
const _hoisted_9 = { class: "body create-account" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Email", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Password", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Confirm Password", -1))
const _hoisted_13 = {
  key: 0,
  class: "error-message"
}
const _hoisted_14 = { class: "button-wrapper" }
const _hoisted_15 = { class: "sub-header" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.loading)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [], 64))
      : ($setup.pageState === 'sign-in')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _hoisted_2,
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", {
                class: _normalizeClass(["input-wrapper", {'active': $setup.emailFocused | $setup.email.length > 0}])
              }, [
                _hoisted_4,
                _withDirectives(_createElementVNode("input", {
                  type: "email",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.email) = $event)),
                  onFocus: _cache[1] || (_cache[1] = ($event: any) => ($setup.emailFocused = true)),
                  onBlur: _cache[2] || (_cache[2] = ($event: any) => ($setup.emailFocused = false))
                }, null, 544), [
                  [_vModelText, $setup.email]
                ])
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(["input-wrapper", {'active': $setup.passwordFocused | $setup.password.length > 0}])
              }, [
                _hoisted_5,
                _withDirectives(_createElementVNode("input", {
                  type: "password",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.password) = $event)),
                  onFocus: _cache[4] || (_cache[4] = ($event: any) => ($setup.passwordFocused = true)),
                  onBlur: _cache[5] || (_cache[5] = ($event: any) => ($setup.passwordFocused = false))
                }, null, 544), [
                  [_vModelText, $setup.password]
                ])
              ], 2),
              ($setup.error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString($setup.error), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("button", {
                  class: "primary-btn",
                  onClick: $setup.doLogin
                }, "Sign In"),
                _createElementVNode("button", {
                  class: "secondary-btn",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.pageState = 'create-account'))
                }, "Create Account")
              ])
            ])
          ], 64))
        : ($setup.pageState === 'create-account')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", {
                  class: _normalizeClass(["input-wrapper", {'active': $setup.emailFocused | $setup.email.length > 0}])
                }, [
                  _hoisted_10,
                  _withDirectives(_createElementVNode("input", {
                    type: "email",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.email) = $event)),
                    onFocus: _cache[8] || (_cache[8] = ($event: any) => ($setup.emailFocused = true)),
                    onBlur: _cache[9] || (_cache[9] = ($event: any) => ($setup.emailFocused = false))
                  }, null, 544), [
                    [_vModelText, $setup.email]
                  ])
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["input-wrapper", {'active': $setup.passwordFocused | $setup.password.length > 0}])
                }, [
                  _hoisted_11,
                  _withDirectives(_createElementVNode("input", {
                    type: "password",
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.password) = $event)),
                    onFocus: _cache[11] || (_cache[11] = ($event: any) => ($setup.passwordFocused = true)),
                    onBlur: _cache[12] || (_cache[12] = ($event: any) => ($setup.passwordFocused = false))
                  }, null, 544), [
                    [_vModelText, $setup.password]
                  ])
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["input-wrapper", {'active': $setup.confirmPassFocused | $setup.confirmPass.length > 0}])
                }, [
                  _hoisted_12,
                  _withDirectives(_createElementVNode("input", {
                    type: "password",
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (($setup.confirmPass) = $event)),
                    onFocus: _cache[14] || (_cache[14] = ($event: any) => ($setup.confirmPassFocused = true)),
                    onBlur: _cache[15] || (_cache[15] = ($event: any) => ($setup.confirmPassFocused = false))
                  }, null, 544), [
                    [_vModelText, $setup.confirmPass]
                  ])
                ], 2),
                ($setup.error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString($setup.error), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("button", {
                    class: "primary-btn",
                    onClick: $setup.doSignup
                  }, "Create Account"),
                  _createElementVNode("button", {
                    class: "secondary-btn",
                    onClick: _cache[16] || (_cache[16] = ($event: any) => ($setup.pageState = 'sign-in'))
                  }, "Sign In")
                ])
              ])
            ], 64))
          : ($setup.pageState === 'logged-in')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                _createElementVNode("div", _hoisted_15, "Logged in as " + _toDisplayString($setup.auth.user.email), 1),
                _createElementVNode("div", { class: "body" }, [
                  _createElementVNode("button", {
                    class: "primary-btn",
                    onClick: $setup.doLogout
                  }, "Logout")
                ])
              ], 64))
            : _createCommentVNode("", true)
  ]))
}